import { render, staticRenderFns } from "./ApprovalDetails.vue?vue&type=template&id=426eb501&scoped=true&"
import script from "./ApprovalDetails.vue?vue&type=script&lang=js&"
export * from "./ApprovalDetails.vue?vue&type=script&lang=js&"
import style0 from "./ApprovalDetails.vue?vue&type=style&index=0&id=426eb501&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "426eb501",
  null
  
)

export default component.exports